import type { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';
import { JobsHttpService } from '@core/offers-data';
import type { OfferFull } from '@core/offers-types';

export const ViewsJobsActions = createActions('ViewsJobs', {
  follow: ngrxEvent<{ id: number }>(),
  followSuccess: ngrxEvent<{ job: OfferFull }>(),
  followFailed: ngrxEvent<{ id: number; error: HttpErrorResponse }>(),

  unfollow: ngrxEvent<{ id: number }>(),
  unfollowSuccess: ngrxEvent<{ job: OfferFull }>(),
  unfollowFailed: ngrxEvent<{ id: number; error: HttpErrorResponse }>(),
});

@Injectable({ providedIn: 'root' })
export class ViewsJobsEffects {
  private readonly actions$ = inject(Actions);
  private readonly jobsHttpService = inject(JobsHttpService);
  public follow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewsJobsActions.follow),
      mergeMap(({ payload }) =>
        this.jobsHttpService.follow(payload.id).pipe(
          switchMap(response => [
            ViewsJobsActions.followSuccess({
              payload: { job: response.offer },
            }),
          ]),
          catchError(error =>
            of(ViewsJobsActions.followFailed({ payload: { error, id: payload.id } })),
          ),
        ),
      ),
    ),
  );

  public unfollow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewsJobsActions.unfollow),
      mergeMap(({ payload }) =>
        this.jobsHttpService.unfollow(payload.id).pipe(
          switchMap(response => [
            ViewsJobsActions.unfollowSuccess({
              payload: { job: response.offer },
            }),
          ]),
          catchError(error =>
            of(ViewsJobsActions.unfollowFailed({ payload: { error, id: payload.id } })),
          ),
        ),
      ),
    ),
  );
}
